import type * as SchemaTypes from '../../../apolloClient.types';

import type { ProgramItemDataFragment } from '../CreateProgram/CreateProgram.api';
import { gql } from '@apollo/client';
import { ProgramItemDataFragmentDoc } from '../CreateProgram/CreateProgram.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateProgramMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateProgramInput;
}>;


export type UpdateProgramMutation = (
  { __typename: 'Mutation' }
  & { updateProgram: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateProgramSuccessfulResponse' }
    & { result: (
      { __typename: 'Program' }
      & ProgramItemDataFragment
    ) }
  ) }
);


export const UpdateProgramDocument = /*#__PURE__*/ gql`
    mutation UpdateProgram($id: ObjectID!, $companyId: ObjectID!, $input: UpdateProgramInput!) {
  updateProgram(id: $id, companyId: $companyId, input: $input) {
    __typename
    ... on UpdateProgramSuccessfulResponse {
      result {
        ...ProgramItemData
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${ProgramItemDataFragmentDoc}`;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<UpdateProgramMutation, UpdateProgramMutationVariables>;